import { render, staticRenderFns } from "./CRButton.vue?vue&type=template&id=4a46d49e&scoped=true"
import script from "./CRButton.vue?vue&type=script&lang=js"
export * from "./CRButton.vue?vue&type=script&lang=js"
import style0 from "./CRButton.vue?vue&type=style&index=0&id=4a46d49e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a46d49e",
  null
  
)

export default component.exports